import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Modal, Button, Badge, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { VerticalForm, FormInput } from '../../../../components';
import Table from '../../../../components/Table';
import {
    addDCCircuitAPI,
    addStationAPI,
    deleteDCCircuitAPI,
    deleteStationAPI,
    editDCCircuitAPI,
    editStationAPI,
    getAllDivisionsAPI,
    getAllStationAPI,
    getAllVendorsAPI,
    getAllZonesAPI,
    getUserProfile,
} from '../../../../API/RDPMS_API';
import moment from 'moment';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { Loading } from 'react-loading-ui';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthActionTypes } from '../../../../redux/auth/constants';
import { authApiResponseSuccess, updateUserAfterStationAdd } from '../../../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import '../../../../../src/assets/scss/custom/components/_addstation.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import { useForm } from 'react-hook-form';
import * as bootstrap from 'bootstrap';
import { addStationColumns, sizePerPageList } from '../../../../utils/ColumnUtils';
import { APICore } from '../../../../helpers/api/apiCore';

const api = new APICore();
const AddStation = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [stationName, setStationName] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showEditModalData, setShowEditModalData] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [stationToDelete, setStationToDelete] = useState(null);

    const [vendor, setVendor] = useState([]);
    const [zone, setZone] = useState([]);
    const [division, setDivision] = useState([]);

    useEffect(() => {
        getAllStationData();
        getAllVendorsData();
        getAllZoneData();
    }, []);

    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    let userId = auth && auth.user && auth.user.id && auth.user.id;

    const getAllVendorsData = async () => {
        try {
            Loading();

            let response = await getAllVendorsAPI();

            if (response && response?.length > 0) {
                setVendor(response);
            }
        } catch (error) {
            console.error('Error vendor data:', error);
            toast.error(t('Failed to refresh vendor data'), {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };

    const getAllZoneData = async () => {
        try {
            Loading();

            let response = await getAllZonesAPI();

            if (response && response?.length > 0) {
                setZone(response);
            }
        } catch (error) {
            console.error('Error zone data:', error);
            toast.error(t('Failed to refresh zone data'), {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };

    const getAllDivisionData = async (id) => {
        try {
            let response = await getAllDivisionsAPI(id);

            if (response && response?.length > 0) {
                setDivision(response);
            }
        } catch (error) {
            console.error('Error division data:', error);
            toast.error(t('Failed to refresh division data'), {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    const getAllStationData = async (limits, pages) => {
        try {
            Loading();
            let limitNumber = limits || limit;
            let pagesNumber = pages || pageNumber;

            let request = {
                limit: limitNumber,
                page: pagesNumber,
                userId,
            };
            let response = await getAllStationAPI(request);

            if (response && response.data && response.data.length > 0) {
                let dataArray = response.data.map((item) => {
                    return {
                        id: item.id,
                        createdDate: moment(item.updatedAt).format('Do MMM YYYY, h:mm A'),
                        zoneName: item?.zone_details?.zone_name,
                        zoneCode: item?.zone_details?.zone_code,

                        divisionName: item?.division_details?.division_name,
                        divisionCode: item?.division_details?.division_code,

                        stationName: item?.name,
                        stationCode: item.station_code,

                        stationMasterName: item.station_master,

                        city: item.city,
                        state: item.state,

                        hardware: item?.hardware_details?.vendor_cloud_name,
                        software: item?.software_details?.vendor_cloud_name,

                        action: (
                            <>
                                <div className="d-flex justify-content-center align-items-center gap-1">
                                    <Link
                                        to="#"
                                        className="action-icon"
                                        onClick={() => openEditModalWithHeaderClass(item)}>
                                        <i className="mdi mdi-pencil"></i>
                                    </Link>
                                    <Link
                                        to="#"
                                        className="action-icon text-danger"
                                        onClick={() => openDeleteModal(item.id)}>
                                        <i className="mdi mdi-delete"></i>
                                    </Link>
                                </div>
                            </>
                        ),
                    };
                });

                setPageNumber(response.currentPage);
                setPageCount(response.totalPages);
                setData(dataArray);
                setTotalCount(response.totalCount);

                new bootstrap.Modal(document.getElementById('updateStation')).show();
            } else {
                toast.error(t('No station data found'), {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error('Error fetching station data:', error);
            toast.error(t('Failed to refresh station data'), {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };

    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAllStationData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAllStationData(limit, value);
    };

    const closeModalWithHeaderClass = () => {
        setShowModal(false);
        reset();
    };
    const openModalWithHeaderClass = () => {
        setShowModal(true);
    };

    const closeEditModalWithHeaderClass = () => {
        setShowEditModal(false);
        resetEdit();
    };
    const openEditModalWithHeaderClass = async (data) => {
        const zoneId = data?.zone_details?.id;
        await getAllDivisionData(zoneId);
        setShowEditModalData(data);
        setShowEditModal(true);
    };

    const openDeleteModal = (id) => {
        setStationToDelete(id);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setStationToDelete(null);
    };

    const schemaResolver = yupResolver(
        yup.object().shape({
            zone: yup.string().required('Please enter zone name'),
            division: yup.string().required('Please enter division name'),

            stationName: yup.string().required('Please enter station name'),
            stationCode: yup.string().required('Please enter station code'),
            stationId: yup.string().required('Please enter station id value'),
            stationMaster: yup.string().required('Please enter station master'),

            city: yup.string().required(t('Please enter city name')),
            state: yup.string().required(t('Please enter state name')),

            hardware: yup.string(),
            software: yup.string(),
        })
    );

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: schemaResolver,
    });

    const {
        register: registerEdit,
        handleSubmit: handleSubmitEdit,
        formState: { errors: errorsEdit },
        reset: resetEdit,
        setValue: setValueEdit,
    } = useForm({
        resolver: schemaResolver,
    });

    useEffect(() => {
        if (showEditModal && showEditModalData) {
            setValueEdit('zone', showEditModalData?.zone_details?.id || '');
            setValueEdit('division', showEditModalData?.division_details?.id || '');
            setValueEdit('stationName', showEditModalData?.name || '');
            setValueEdit('stationCode', showEditModalData?.station_code || '');
            setValueEdit('stationId', showEditModalData?.station_id || '');

            setValueEdit('stationMaster', showEditModalData?.station_master || '');
            setValueEdit('city', showEditModalData?.city || '');
            setValueEdit('state', showEditModalData?.state || '');

            setValueEdit('hardware', showEditModalData?.hardware_details?.id || '');
            setValueEdit('software', showEditModalData?.software_details?.id || '');
        }
    }, [showEditModal, showEditModalData, setValueEdit]);

    const onSubmit = async (formData) => {
        setLoader(true);
        formData.userId = userId;

        const selectedZoneId = formData?.zone;
        const selectedZone = zone.find((z) => z.id === selectedZoneId);

        if (selectedZone) {
            formData.zoneName = selectedZone.zone_name;
        }

        let result = await addStationAPI(formData);
        if (result) {
            let user = await getUserProfile(userId);
            if (result) {
                dispatch(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
                api.setLoggedInUser(user);
            }

            getAllStationData();
            setShowModal(false);
            reset();
        } else {
            toast.error('Please enter different station', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        setLoader(false);
    };

    const onEdit = async (formData) => {
        setLoader(true);
        formData.userId = userId;
        formData.id = showEditModalData.id;

        const selectedZoneId = formData?.zone;
        const selectedZone = zone.find((z) => z.id === selectedZoneId);

        if (selectedZone) {
            formData.zoneName = selectedZone.zone_name;
        }

        let result = await editStationAPI(formData);
        if (result) {
            let user = await getUserProfile(userId);
            if (user) {
                // dispatch(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
                dispatch(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
                api.setLoggedInUser(user);
            }
            getAllStationData();
            setShowEditModal(false);
            resetEdit();
        } else {
            toast.error('Failed to update station', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        setLoader(false);
    };

    const onDeleteStation = async () => {
        if (!stationToDelete) return;

        Loading();
        let result = await deleteStationAPI(stationToDelete);

        if (result) {
            let user = await getUserProfile(userId);
            if (user) {
                dispatch(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
            }
            getAllStationData();
            toast.success('Deleted station successfully', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } else {
            toast.error('Failed to delete station', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        closeDeleteModal();
        Loading();
    };

    return (
        <div style={{ width: '100%' }}>
            <div className="row ">
                <div className="w-100 d-flex justify-content-between">
                    <div className="col-sm-6" style={{ marginLeft: '-2rem' }}>
                        <button className="btn_1 ">{t('STATION')}</button>
                    </div>
                    <div className="col-sm-6 d-flex justify-content-end">
                        <Button className="export text-black" onClick={openModalWithHeaderClass}>
                            <span className="d-flex align-items-center gap-1">
                                {t('ADD STATION')} <i className="fas fa-plus"></i>
                            </span>
                        </Button>
                        <button
                            className="update"
                            id="update"
                            type="button"
                            onClick={() => getAllStationData(limit, pageNumber)}>
                            {t('Update')} <i className="fas fa-sync-alt"></i>
                        </button>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={closeModalWithHeaderClass} centered size="lg">
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Add Station')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            {/* Zone Section */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Zone Name')}</label>
                                <select
                                    className={`form-select ${errors.zone ? 'is-invalid' : ''}`}
                                    {...register('zone')}
                                    defaultValue=""
                                    onChange={(e) => getAllDivisionData(e.target.value)}>
                                    <option value="" disabled>
                                        {t(' Select Zone')}
                                    </option>
                                    {zone.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.zone_name}
                                        </option>
                                    ))}
                                </select>
                                {errors.zone && <p className="text-danger">{errors.zone.message}</p>}
                            </div>

                            {/* Division Section */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Division Name')}</label>
                                <select
                                    className={`form-select ${errors.division ? 'is-invalid' : ''}`}
                                    {...register('division')}
                                    defaultValue="">
                                    <option value="" disabled>
                                        {t('Select Division')}
                                    </option>
                                    {division.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.division_name}
                                        </option>
                                    ))}
                                </select>
                                {errors.division && <p className="text-danger">{errors.division.message}</p>}
                            </div>

                            {/* Station Section */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Station Name')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.stationName ? 'is-invalid' : ''}`}
                                    {...register('stationName')}
                                    placeholder="Enter Station Name"
                                />
                                {errors.stationName && <p className="text-danger">{errors.stationName.message}</p>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Station Code')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.stationCode ? 'is-invalid' : ''}`}
                                    {...register('stationCode')}
                                    placeholder="Enter Station Code"
                                />
                                {errors.stationCode && <p className="text-danger">{errors.stationCode.message}</p>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Station ID')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.stationId ? 'is-invalid' : ''}`}
                                    {...register('stationId')}
                                    placeholder="Enter Station ID"
                                />
                                {errors.stationId && <p className="text-danger">{errors.stationId.message}</p>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Station Master')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.stationMaster ? 'is-invalid' : ''}`}
                                    {...register('stationMaster')}
                                    placeholder="Enter Station ID"
                                />
                                {errors.stationMaster && <p className="text-danger">{errors.stationMaster.message}</p>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="city" className="form-label">
                                    {t('City')}
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.city ? 'is-invalid' : ''}`}
                                    placeholder="Enter City"
                                    id="city"
                                    {...register('city')}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    }}
                                />
                                {errors.city && <p className="text-danger">{errors.city.message}</p>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="state" className="form-label">
                                    {t('State')}
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.state ? 'is-invalid' : ''}`}
                                    placeholder="Enter State"
                                    id="state"
                                    {...register('state')}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    }}
                                />
                                {errors.state && <p className="text-danger">{errors.state.message}</p>}
                            </div>

                            {/* Vendor Section */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Hardware')}</label>
                                <select
                                    className={`form-select ${errors.hardware ? 'is-invalid' : ''}`}
                                    {...register('hardware')}
                                    defaultValue="">
                                    <option value="" disabled>
                                        {t('Select Vendor Name')}
                                    </option>
                                    {vendor.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.vendor_cloud_name}
                                        </option>
                                    ))}
                                </select>
                                {errors.hardware?.message && <p className="text-danger">{errors.hardware.message}</p>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Software')}</label>
                                <select
                                    className={`form-select ${errors.software ? 'is-invalid' : ''}`}
                                    {...register('software')}
                                    defaultValue="">
                                    <option value="" disabled>
                                        {t('Select Vendor Name')}
                                    </option>
                                    {vendor.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.vendor_cloud_name}
                                        </option>
                                    ))}
                                </select>
                                {errors.software?.message && <p className="text-danger">{errors.software.message}</p>}
                            </div>
                        </div>

                        {/* Submit */}
                        <div className="d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-submit"
                                style={{
                                    backgroundColor: '#F9B74C',
                                    fontFamily: 'Poppins, sans-serif',
                                    width: '200px',
                                    borderRadius: '0%',
                                    border: 'none',
                                }}
                                disabled={loader}>
                                {loader ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="grow"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        {t('Loading')}
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-login"></i>
                                        {t('Submit')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal show={showEditModal} onHide={closeEditModalWithHeaderClass} centered size="lg">
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Edit Station')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmitEdit(onEdit)}>
                        <div className="row">
                            {/* Zone */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Zone Name')}</label>
                                <select
                                    className={`form-select ${errorsEdit.zone ? 'is-invalid' : ''}`}
                                    {...registerEdit('zone')}
                                    onChange={(e) => getAllDivisionData(e.target.value)}>
                                    <option value="" disabled>
                                        Select Zone
                                    </option>
                                    {zone.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.zone_name}
                                        </option>
                                    ))}
                                </select>
                                {errorsEdit.zone && <p className="text-danger">{errorsEdit.zone.message}</p>}
                            </div>

                            {/* Division */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Division Name')}</label>
                                <select
                                    className={`form-select ${errorsEdit.division ? 'is-invalid' : ''}`}
                                    {...registerEdit('division')}>
                                    <option value="" disabled>
                                        Select Division
                                    </option>
                                    {division.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.division_name}
                                        </option>
                                    ))}
                                </select>
                                {errorsEdit.division && <p className="text-danger">{errorsEdit.division.message}</p>}
                            </div>

                            {/* Station Name */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Station Name')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errorsEdit.stationName ? 'is-invalid' : ''}`}
                                    {...registerEdit('stationName')}
                                    placeholder="Enter Station Name"
                                />
                                {errorsEdit.stationName && (
                                    <p className="text-danger">{errorsEdit.stationName.message}</p>
                                )}
                            </div>

                            {/* Station Code */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Station Code')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errorsEdit.stationCode ? 'is-invalid' : ''}`}
                                    {...registerEdit('stationCode')}
                                    placeholder="Enter Station Code"
                                />
                                {errorsEdit.stationCode && (
                                    <p className="text-danger">{errorsEdit.stationCode.message}</p>
                                )}
                            </div>

                            {/* Station ID */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Station ID')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errorsEdit.stationId ? 'is-invalid' : ''}`}
                                    {...registerEdit('stationId')}
                                    placeholder="Enter Station ID"
                                />
                                {errorsEdit.stationId && <p className="text-danger">{errorsEdit.stationId.message}</p>}
                            </div>

                            {/* Station Master */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Station Master')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errorsEdit.stationMaster ? 'is-invalid' : ''}`}
                                    {...registerEdit('stationMaster')}
                                    placeholder="Enter Station Master"
                                />
                                {errorsEdit.stationMaster && (
                                    <p className="text-danger">{errorsEdit.stationMaster.message}</p>
                                )}
                            </div>

                            {/* City */}
                            <div className="col-md-6 mb-3">
                                <label htmlFor="editCity" className="form-label">
                                    {t('City')}
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errorsEdit.city ? 'is-invalid' : ''}`}
                                    placeholder="Enter City"
                                    id="editCity"
                                    {...registerEdit('city')}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    }}
                                />
                                {errorsEdit.city && <p className="text-danger">{errorsEdit.city.message}</p>}
                            </div>

                            {/* State */}
                            <div className="col-md-6 mb-3">
                                <label htmlFor="editState" className="form-label">
                                    {t('State')}
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errorsEdit.state ? 'is-invalid' : ''}`}
                                    placeholder="Enter State"
                                    id="editState"
                                    {...registerEdit('state')}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    }}
                                />
                                {errorsEdit.state && <p className="text-danger">{errorsEdit.state.message}</p>}
                            </div>

                            {/* Hardware */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Hardware')}</label>
                                <select
                                    className={`form-select ${errorsEdit.hardware ? 'is-invalid' : ''}`}
                                    {...registerEdit('hardware')}>
                                    <option value="" disabled>
                                        Select Vendor Name
                                    </option>
                                    {vendor.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.vendor_cloud_name}
                                        </option>
                                    ))}
                                </select>
                                {errorsEdit.hardware && <p className="text-danger">{errorsEdit.hardware.message}</p>}
                            </div>

                            {/* Software */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Software')}</label>
                                <select
                                    className={`form-select ${errorsEdit.software ? 'is-invalid' : ''}`}
                                    {...registerEdit('software')}>
                                    <option value="" disabled>
                                        Select Vendor Name
                                    </option>
                                    {vendor.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.vendor_cloud_name}
                                        </option>
                                    ))}
                                </select>
                                {errorsEdit.software && <p className="text-danger">{errorsEdit.software.message}</p>}
                            </div>

                            {/* Created Date */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Created Date')}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={moment(showEditModalData?.updatedAt).format('Do MMM YYYY, h:mm A')}
                                    disabled
                                />
                            </div>
                        </div>

                        {/* Submit */}
                        <div className="d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-submit"
                                style={{
                                    backgroundColor: '#F9B74C',
                                    fontFamily: 'Poppins, sans-serif',
                                    width: '200px',
                                    borderRadius: '0%',
                                    border: 'none',
                                }}
                                disabled={loader}>
                                {loader ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="grow"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        {t('Loading')}
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-login"></i>
                                        {t('Submit')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <div
                className="modal fade"
                id="updateStation"
                tabIndex="-1"
                aria-labelledby="updateStationLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header close">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-3">{t('Station data refreshed successfully')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Delete Station')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img
                        src="/asset-images/deleteiconmodal.png"
                        alt="Delete"
                        className="img-fluid"
                        style={{ maxWidth: '100px' }}
                    />
                    <p className="mt-3">{t('Are you sure you want to delete this station?')}</p>
                    <div className="d-flex justify-content-center gap-2">
                        <Button
                            variant="secondary"
                            onClick={closeDeleteModal}
                            style={{
                                width: '100px',
                                borderRadius: '0',
                            }}>
                            No
                        </Button>
                        <Button
                            variant="outline-danger"
                            onClick={onDeleteStation}
                            style={{
                                width: '100px',
                                borderRadius: '0',
                                border: '2px solid red',
                            }}>
                            Yes
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <div
                className="col-6 col-sm-6 card-add-station p-3 border-0 text-start no-radius my-2"
                style={{
                    width: '100%',
                    boxShadow: '0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                    position: 'relative',
                }}>
                <div className="row align-items-center mb-2"></div>
                <div className="station-table-wrapper">
                    <Table
                        columns={addStationColumns(t)}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddStation;
